import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { BaseRule, ApplyRule } from '../type'
import { createUpdateRuleProps } from '../createUpdateRuleProps'
import List from '../List'
import { OPTIONS_EXTENSION_TYPE } from '../const'
import Number from '../Number'
import Text from '../Text'
import { registerRule } from '../index'
import styled from 'styled-components'

interface RuleCSVLine extends BaseRule {
    props: RuleCSVLineProps
    ruleName?: 'DynamicPositionHeader'
}

interface RuleCSVLineProps {
    row: string
    column?: string
    fileNameRule: string
    sheetIndexRule: string
    extensionType: string
}
interface Props extends RuleCSVLine {
    onChange: (rule: RuleCSVLine) => void
}

export default function CsvLineHeader({
    applyRule,
    onChange,
    ruleName = 'DynamicPositionHeader',
    props
}: Props): JSX.Element {
    const [updateProps, setUpdate] = useState<(rule: RuleCSVLineProps) => void>()

    useEffect(() => {
        setUpdate(() => createUpdateRuleProps<RuleCSVLineProps>({ applyRule, onChange, ruleName }))
    }, [applyRule])

    const valueApplyRule = Object.entries(ApplyRule).find(([k, v]) => k === applyRule)

    return (
        <Content>
            <List
                label="When to apply this rule"
                value={{ label: valueApplyRule[1], value: valueApplyRule[0] }}
                onChange={option =>
                    onChange({
                        applyRule: option?.value as ApplyRule,
                        props,
                        ruleName
                    })
                }
                options={Object.entries(ApplyRule)
                    .filter(([k, v]) => typeof v === 'string')
                    .map(([k, v]) => ({ label: v, value: k }))}
            />
            <Text<RuleCSVLineProps>
                label="File name"
                disabled={ApplyRule.Always == applyRule}
                name="fileNameRule"
                onChange={updateProps}
                props={props}
            />
            <List
                label="Extension type"
                value={OPTIONS_EXTENSION_TYPE.find(({ value }) => value == props?.extensionType)}
                onChange={option => updateProps({ ...props, extensionType: option.value })}
                options={OPTIONS_EXTENSION_TYPE}
            />
            <Number<RuleCSVLineProps> label="Start reading from row:" name="row" onChange={updateProps} props={props} />

            <Number<RuleCSVLineProps>
                disabled={props.extensionType === 'csv'}
                label="Start reading from column:"
                name="column"
                onChange={updateProps}
                props={props}
            />
        </Content>
    )
}
const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 5px;
`
registerRule({
    label: 'Dynamic Position Header',
    ruleName: 'DynamicPositionHeader',
    defaultProps: {
        extensionType: 'csv',
        fileNameRule: '',
        row: '0',
        column: '',
        sheetIndexRule: ''
    } as RuleCSVLineProps
})({ Component: CsvLineHeader })

export { RuleCSVLine, RuleCSVLineProps }
